const GOLDEN_RATIO_CONJUGATE = 0.618033988749;

export const evenlySpread = (index: number) => (index * GOLDEN_RATIO_CONJUGATE) % 1;
